import React from 'react';
import { SectionHeading } from './Section';
import { perfStats } from '../../../data/reportPhilly';
// Campaign headline numbers — flat, square, cabernet-tinted stat cards.
export function PerformanceV5() {
  return <section className="print:break-before-page" data-id="element-775" data-mp="3g7spu3utb4gs">
      <SectionHeading eyebrow="Performance" title="The numbers behind the reach" data-id="element-776" data-mp="3b7wka06gv4z4" />
      <div className="grid gap-4 sm:grid-cols-3" data-id="element-777" data-mp="3p7o3cfbubbjz">
        {perfStats.map(s => <div key={s.label} className="print-keep border border-bhhs-cab/10 bg-bhhs-cab/[0.04] p-5" data-id="element-778" data-mp="3p5bgbnr86b02">
            <p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-muted-foreground" data-id="element-779" data-mp="2scvbdctw8pv">
              {s.label}
            </p>
            <p className="font-display mt-1 text-4xl font-semibold tracking-tight text-bhhs-cab" data-id="element-780" data-mp="3tz64p4hrze5h">
              {s.value}
            </p>
            <p className="mt-1 text-xs text-muted-foreground" data-id="element-781" data-mp="7rg2p4ga6r10">{s.sub}</p>
          </div>)}
      </div>
    </section>;
}